import {
  INTERNAL_DOCTOR,
  INTERNAL_DOCTOR_SUCCESS,
  INTERNAL_DOCTOR_FAILURE,
} from 'store/internalDoctor/internalDoctorAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const internalDoctorReducer = (state = initialState, action) => {
  switch (action.type) {
    case INTERNAL_DOCTOR:
      return { ...state, loading: true };
    case INTERNAL_DOCTOR_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case INTERNAL_DOCTOR_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default internalDoctorReducer;
